// extracted by mini-css-extract-plugin
export default {"noSpaces":"styles_noSpaces__cWxpv"};